import React from 'react';
import PropTypes from 'prop-types';

// Import Local Styles
import styles from './checkbox.css';

const Checkbox = (props) => {
    const { checked, name, onChange, modifier, readOnly, label, alternateColor, checkTheme } = props;
    return (
        <div className={`${styles.wrapper} ${modifier}`}>
            <input
                checked={checked}
                className={styles.checkbox}
                id={name}
                onChange={onChange}
                readOnly={readOnly}
                type='checkbox'
            />
            <label
                className={`${styles.label} ${alternateColor ? styles['alternate-colors'] : ''} ${checkTheme ? styles[`label--check-${checkTheme}`] : ''} ${checked ? styles['label--checked'] : ''}`}
                htmlFor={name}
            >{label}</label>
        </div>
    );
};

Checkbox.propTypes = {
    checked: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    modifier: PropTypes.string,
    readOnly: PropTypes.bool,
    label: PropTypes.string,
    alternateColor: PropTypes.bool
};

Checkbox.defaultProps = {
    checked: false,
    readOnly: false,
    onChange: () => null,
    modifier: '',
    label: '',
    alternateColor: false
};

export default Checkbox;
